import { render, staticRenderFns } from "./register.vue?vue&type=template&id=05964dc3&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=05964dc3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05964dc3",
  null
  
)

export default component.exports